import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=66391e62&scoped=true&"
import script from "./Buttons.vue?vue&type=script&lang=ts&"
export * from "./Buttons.vue?vue&type=script&lang=ts&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=66391e62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66391e62",
  null
  
)

export default component.exports